export const CONTACT_SALES_PACKAGE_IDS = new Set(['enterprise', 'custom']);

export function isContactSalesPackage(pkg) {
  if (!pkg) return false;
  if (pkg.contactOnly === true) return true;

  const id = String(pkg.id || '').trim().toLowerCase();
  const slug = String(pkg.slug || '').trim().toLowerCase();
  return CONTACT_SALES_PACKAGE_IDS.has(id) || CONTACT_SALES_PACKAGE_IDS.has(slug);
}

export function getContactSalesNavigationState(pkg) {
  const planName = pkg?.name === 'Enterprise' ? 'Custom' : (pkg?.name || 'Custom');
  return {
    subject: `${planName} plan inquiry`,
    message: `Hi, I'm interested in the ${planName} plan and would like to learn more about pricing and features.`,
    planId: pkg?.id || 'custom',
    planName,
  };
}
